import axios from "axios";

export const state = {
    subscriptions: [],
};

export const getters = {
    subscriptions: state => state.subscriptions,
};

export const mutations = {
    setSubscriptions(state, newValue) {
        state.subscriptions = newValue
    },
};

export const actions = {
    fetchSubscriptions({ commit }) {
        axios.get('/subscription').then(res => {
            commit('setSubscriptions', res.data.subscriptions)
        })
    },
};
